<template>
  <div
    class="relative rounded-md border border-background-fg/8"
  >
    <input
      v-model="inputValue"
      type="number"
      step="0.01"
      :name="name"
      :class="[
        'block w-full rounded-md bg-background-fg/5 pr-12 text-right text-sm font-semibold focus:outline-none sm:text-sm',
        // textInputSelected
        //   ? 'ring-primary border-primary border-2'
        //   : 'border-background-fg/8',
        props.highlight
          ? 'border-primary ring-primary focus:border-primary focus:ring-primary'
          : hasError
            ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
            : 'border-none focus:border-primary focus:ring-primary',
      ]"
      :aria-invalid="!!hasError"
      :disabled="disabled"
      enterKeyHint="done"
      :min="min"
      @blur="handleBlur"
      @keydown.backspace="handleBackspace"
      @keydown.enter="handleEnter"
    />
    <div
      :class="[
        props.highlight
          ? 'bg-primary text-primary-fg'
          : 'bg-background text-background-fg',
        'absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-md border-l border-background-fg/8',
      ]"
    >
      <span class="font-semibold"> % </span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    highlight?: boolean
    modelValue: number
    name?: string
    hasError?: boolean
    disabled?: boolean
    min?: number
  }>(),
  {
    highlight: false,
    name: undefined,
    hasError: false,
    disabled: false,
    supervisorRequired: false,
    min: undefined,
  }
)

const emit =
  defineEmits<
    (
      eventName: "update:modelValue",
      value: number | null
    ) => void
  >()

const inputValue = ref(0)

watch(
  () => props.modelValue,
  (value) => {
    inputValue.value = value ?? 0
  },
  { immediate: true }
)
const handleBlur = async () => {
  inputValue.value = Math.min(Number(inputValue.value), 100)
  emit("update:modelValue", inputValue.value)
}

const handleBackspace = (event: KeyboardEvent) => {
  if (inputValue.value === 0) {
    event.preventDefault()
  }
}

const handleEnter = (event: Event) =>
  (event?.target as HTMLInputElement)?.blur()
</script>
